import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Active, ActiveButton } from "../../../../Constant";
import { ACTIVE_BUTTONS_LIST, ACTIVE_BUTTONS } from "../../../../Data/Buttons/DefaultStyle";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonButton from "../Common/CommonButton";

const ActiveButtons = () => {
  const [buttonTooltip, setButttooltip] = useState(false);
  const buttonToggle = () => setButttooltip(!buttonTooltip);
  return (
    <Card>
      <CommonCardHeader title={ActiveButton} span={ACTIVE_BUTTONS} />
      <CardBody className="btn-showcase">
        <Btn active color="primary" id="Tooltip-29">{Active}</Btn>
        <ToolTip target="Tooltip-29" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-primary active</ToolTip>
        {ACTIVE_BUTTONS_LIST.map((data, index) => (
          <CommonButton key={index} item={data} active={true} />
        ))}
      </CardBody>
    </Card>
  );
};

export default ActiveButtons;
